import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-105ee8ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "single-select" }
const _hoisted_2 = { class: "single-select__main" }
const _hoisted_3 = { class: "main__selectable" }
const _hoisted_4 = {
  key: 0,
  class: "content__search"
}
const _hoisted_5 = {
  key: 1,
  class: "content__options"
}
const _hoisted_6 = ["onClick", "title"]
const _hoisted_7 = {
  key: 0,
  class: "iconfont icon-duigou"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "main__selected mk-text-overflow" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-shanchu" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]

import { ref, watch } from 'vue'


const __default__ = {
  name: "SingleSelect",
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  // 已选数据，为了实现 v-model
  modelValue: {
    type: [String, Number, Object],
    default: () => ''
  },

  placeholder: {
    type: String,
    default: ''
  },

  // 下拉选择的数据
  optionList: {
    type: Array,
    default: () => []
  },

  // 获取 name 字段
  nameField: {
    type: String,
    default: () => 'name'
  },

  // 获取 value 字段
  valueField: {
    type: String,
    default: () => 'id'
  },

  // 是否支持搜索
  showSearch: {
    type: Boolean,
    default: () => true
  },

  // 是否区分大小写
  caseSensitive: {
    type: Boolean,
    default: () => false
  },

  // 能否清除选择
  clearable: {
    type: Boolean,
    default: () => true
  }
},
  emits: ['update:modelValue', 'change', 'option-click', 'clear'],
  setup(__props, { emit }) {

const props = __props;

const cloneModelValue = ref([])


// 控制 popover 弹框显示与否
const visible = ref(false);
// 搜索的值
const searchValue = ref('');
// 缓存的选项（不使用 reactive 的原因是 reactive 一旦定义了，就不能直接替换整个对象，否则会丢失原有的响应式，而 ref 不会）
const cacheOptionList = ref([])
// popover 宽度
const popoverWidth = ref('200px');
// 显示的选项
const showOptionList = ref([])

// 获取显示名
const getDisplayName = (value) => {
  let target;
  for (let i = 0, len = cacheOptionList.value.length; i < len; i++) {
    if (value === cacheOptionList.value[i][props.valueField]) {
      target = cacheOptionList.value[i];
    }
  }
  return target ? target[props.nameField] : value;
}



const mainSelectWrapRef = ref(null)
// 已选展示区域点击事件
const onMainSelectWrapClick = () => {
  let clientWidth = mainSelectWrapRef.value.clientWidth;
  // 最小宽度为 200px
  clientWidth = clientWidth > 200 ? clientWidth : 200;
  popoverWidth.value = clientWidth + 'px';
}

// 弹框各项点击事件
const optionItemClick = (item) => {
  let itemValue = item[props.valueField];
  emit('update:modelValue', itemValue);
  emit('change', itemValue);
  // 下拉选择项点击事件参数分别为 点击项对象
  emit('option-click', item);
  visible.value = false;
}

watch(() => visible.value, (value) => {
  console.log(value)
})

// 所选值删除事件
const onValueClear = (event) => {
  // 阻止点击事件冒泡，防止弹出下拉框
  event.stopPropagation();
  emit('update:modelValue', '');
  emit('change', '');
  emit('clear', '')
}

// 搜索框输入事件
const onSearchInput = (value) => {
  value = (value === 0 || value) ? (value + '') : '';
  showOptionList.value = cacheOptionList.value.filter(item => {
    let name = item[props.nameField];
    // 防止传入的 name 不是字符类型
    name = (name === 0 || name) ? (name + '') : '';

    if (!props.caseSensitive) {
      // 不区分大小写
      return name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    } else {
      return name.indexOf(value) !== -1;
    }
  });
}

watch(() => JSON.parse(JSON.stringify(props.optionList)), (newVal, oldVal) => {
  cacheOptionList.value = JSON.parse(JSON.stringify(newVal || []));
  showOptionList.value = cacheOptionList.value;
}, {
  immediate: true,
  // deep: true
})

watch(()=> props.modelValue, (newVal,oldVal)=> {
  if(newVal) {
    cloneModelValue.value = JSON.parse(JSON.stringify(props.modelValue))
  }
}, {
  immediate:true
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_popover, {
        trigger: "click",
        placement: "bottom",
        "popper-class": "single-select__main__popover mk-popper-default",
        width: popoverWidth.value
      }, {
        reference: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "mainSelectWrapRef",
            ref: mainSelectWrapRef,
            class: "main__selected-warp",
            onClick: onMainSelectWrapClick
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", {
                class: _normalizeClass({'empty_class': getDisplayName(cloneModelValue.value) == '' })
              }, _toDisplayString(getDisplayName(cloneModelValue.value) ||
              _ctx.$t(__props.placeholder)), 3)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["selected__del", { 'selected__del--active': cloneModelValue.value === 0 || cloneModelValue.value }]),
              onClick: onValueClear
            }, _hoisted_11, 2),
            _createElementVNode("div", {
              class: "selected__arrow",
              onClick: onValueClear
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["iconfont", visible.value ? 'icon-shang' : 'icon-xia'])
              }, null, 2)
            ])
          ], 512)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (__props.showSearch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createVNode(_component_el_input, {
                    modelValue: cloneModelValue.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cloneModelValue).value = $event))
                  }, null, 8, ["modelValue"]), [
                    [_vShow, false]
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: searchValue.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
                    onInput: onSearchInput,
                    clearable: true
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (showOptionList.value && showOptionList.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((showOptionList.value || []), (optionItem, optionIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: optionIndex,
                      onClick: ($event: any) => (optionItemClick(optionItem)),
                      class: "options__item mk-text-overflow",
                      title: optionItem[__props.nameField]
                    }, [
                      _createElementVNode("span", null, _toDisplayString(optionItem[__props.nameField]), 1),
                      (cloneModelValue.value === optionItem[__props.valueField])
                        ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_6))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_el_empty)
                ]))
          ])
        ]),
        _: 1
      }, 8, ["width"])
    ])
  ]))
}
}

})